import React from 'react';
import { formatPercentage } from '../lib/formatters';

export const ShareFillIndicator = ({ totalShares, soldShares }) => {
  const fillPercentage = (soldShares / totalShares) * 100;
  const availableShares = totalShares - soldShares;

  return (
    <div data-testid="share-fill-indicator" className="bg-white border border-[hsl(var(--border))] rounded-xl p-6">
      <h3 className="text-lg font-semibold text-[hsl(var(--text-primary))] mb-4">
        Share Availability
      </h3>

      {/* Battery-style indicator */}
      <div className="relative mb-6">
        {/* Battery outline */}
        <div className="h-24 border-4 border-[hsl(var(--border-strong))] rounded-lg relative overflow-hidden">
          {/* Fill */}
          <div
            className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[hsl(var(--brand-primary))] to-[hsl(var(--brand-primary-light))] transition-all duration-500"
            style={{ height: `${fillPercentage}%` }}
          />
          
          {/* Percentage overlay */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-3xl font-bold font-mono mix-blend-difference text-white">
              {formatPercentage(fillPercentage)}
            </div>
          </div>
        </div>
        
        {/* Battery tip */}
        <div className="absolute -right-3 top-1/2 -translate-y-1/2 w-2 h-8 bg-[hsl(var(--border-strong))] rounded-r" />
      </div>

      {/* Numbers */}
      <div className="grid grid-cols-2 gap-4">
        <div className="text-center p-3 bg-[hsl(var(--background-secondary))] rounded-lg">
          <div className="text-2xl font-bold font-mono text-[hsl(var(--gain))]">
            {availableShares}
          </div>
          <div className="text-xs text-[hsl(var(--text-secondary))] mt-1">Available</div>
        </div>
        <div className="text-center p-3 bg-[hsl(var(--background-secondary))] rounded-lg">
          <div className="text-2xl font-bold font-mono text-[hsl(var(--text-primary))]">
            {soldShares}
          </div>
          <div className="text-xs text-[hsl(var(--text-secondary))] mt-1">Sold</div>
        </div>
      </div>
    </div>
  );
};